const sanitizeRoute = (path: string) =>
  path.replace(/\/$/, '').split('/').pop() || '';

export default sanitizeRoute;
